"use strict";

const Poly1305 = require('./lib/poly1305');

module.exports = Poly1305;
